module.exports = __webpack_public_path__ + "media/salicylic-large.4b6747df.mp4";